import { createSelector } from "reselect";
import { selectBookingRequest } from "./selectBookingRequest";

export const selectBookingSupplierRequest = () =>
  createSelector(selectBookingRequest(false), (bookingRequest) => {
    const { supplier } = bookingRequest;
    return supplier!;
  });
